import path from 'node:path';
import { randomUUID } from 'node:crypto';
import { toJsonString } from '@wix/cli-fs';
import { componentGenerator } from '@wix/gena';
import type { SupportedServicePlugin } from '@wix/cli-app-definitions';
import { getExtensionPath } from '@wix/cli-astro-definitions';
import { match } from 'variant';
import type { Component } from '@wix/ambassador-devcenter-apps-v1-app-old/types';
import { ComponentType } from '@wix/ambassador-devcenter-apps-v1-app-old/types';

// NOTE: path is relative to the build folder
const SERVICE_PLUGIN_TEMPLATE = path.resolve(
  __dirname,
  '../templates/astro/service-plugin'
);

export async function generateServicePlugin(
  projectFolder: string,
  servicePluginType: SupportedServicePlugin,
  name: string
) {
  const cwd = getExtensionPath(projectFolder, name);

  const servicePluginConfig: Component = match(servicePluginType, {
    ECOM_ADDITIONAL_FEES: (): Component => ({
      compName: name,
      compId: randomUUID(),
      compType: ComponentType.ECOM_ADDITIONAL_FEES,
      compData: {
        ecomAdditionalFees: {},
      },
    }),
    ECOM_SHIPPING_RATES: (): Component => ({
      compName: name,
      compId: randomUUID(),
      compType: ComponentType.ECOM_SHIPPING_RATES,
      compData: {
        ecomShippingRates: {
          name: 'Shipping Rates Provider',
          description: 'Short description about this shipping provider',
          fallbackDefinitionMandatory: false,
        },
      },
    }),
    ECOM_DISCOUNTS_TRIGGER: (): Component => ({
      compName: name,
      compId: randomUUID(),
      compType: ComponentType.ECOM_DISCOUNTS_TRIGGER,
      compData: {
        ecomDiscountsTrigger: {},
      },
    }),
    ECOM_VALIDATIONS: (): Component => ({
      compName: name,
      compId: randomUUID(),
      compType: ComponentType.ECOM_VALIDATIONS,
      compData: {
        ecomValidations: {
          validateInCart: false,
        },
      },
    }),
    ECOM_PAYMENT_SETTINGS: (): Component => ({
      compName: name,
      compId: randomUUID(),
      compType: ComponentType.ECOM_PAYMENT_SETTINGS,
      compData: {
        ecomPaymentSettings: {
          fallbackValueForRequires3dSecure: false,
        },
      },
    }),
    GIFT_CARDS_PROVIDER: (): Component => ({
      compName: name,
      compId: randomUUID(),
      compType: ComponentType.GIFT_CARDS_PROVIDER,
      compData: {
        giftCardsProvider: {},
      },
    }),
  });

  const servicePluginConfigJSON = toJsonString(servicePluginConfig, {
    spaces: 2,
  });

  const servicePluginTypeLower = servicePluginType
    .toLowerCase()
    .replaceAll('_', '-');

  return await componentGenerator({
    template: path.join(SERVICE_PLUGIN_TEMPLATE, servicePluginTypeLower),
    projectFolder,
    cwd,
    data: {
      servicePluginConfigJSON,
    },
  });
}
